import {ChatService, EventBus} from '@fnd/timeline'
import {ChatMessage} from '@fnd/timeline/dist/timeline/chat/services/ChatMessageSet'

export class AssistantChatService extends ChatService {
  public constructor(eventBus: EventBus) {
    super(eventBus)
  }

  async loadHistory(assignmentId: string): Promise<ChatMessage[]> {
    await this.loadActiveConversations(true)
    return super.loadHistory(assignmentId)
  }

  static instance: AssistantChatService

  static shared(eventBus: EventBus) {
    return (
      AssistantChatService.instance ??
      (AssistantChatService.instance = new AssistantChatService(eventBus))
    )
  }
}
